import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = false;

const slice = createSlice({
  name: '$futureOrderingEnableCateringDelivery',
  initialState,
  reducers: {
    setFutureOrderingEnableCateringDelivery(
      state,
      action: PayloadAction<boolean>,
    ) {
      return Boolean(action.payload);
    },
  },
});

export const { setFutureOrderingEnableCateringDelivery } = slice.actions;
export default slice.reducer;
